module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticStyle: {
      "margin": "0px auto",
      "margin-top": "70px"
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "edit-table",
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    attrs: {
      "inline": false
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "edit-title"
  }, [_vm._v("標題")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    staticClass: "edit-title-input",
    attrs: {
      "placeholder": "填入標題"
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": false
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "edit-brief-title"
  }, [_vm._v("簡介（建議200字以內）")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "edit-brief-input",
    attrs: {
      "placeholder": "輸入文字"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-table"
  }, [_c('div', {
    staticClass: "filter-slot",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "edit-filter-title"
  }, [_vm._v("主題分類")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.classifySelect
    },
    model: {
      value: (_vm.filter.classify.selected),
      callback: function($$v) {
        _vm.$set(_vm.filter.classify, "selected", $$v)
      },
      expression: "filter.classify.selected"
    }
  }, _vm._l((_vm.filter.classify.selectedFilters), function(selectedFilter) {
    return _c('el-option', {
      key: selectedFilter.value,
      attrs: {
        "label": selectedFilter.text,
        "value": selectedFilter.value
      }
    }, [_vm._v(_vm._s(selectedFilter.text))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-slot"
  }, [_c('div', {
    staticClass: "edit-filter-title"
  }, [_vm._v("作者")]), _vm._v(" "), (_vm.show) ? _c('el-form', {
    attrs: {
      "inline": false
    }
  }, [_c('autocomplete', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.authorLoading),
      expression: "authorLoading"
    }],
    ref: "autocomplete",
    attrs: {
      "placeholder": "可輸入作者或帳號…",
      "source": _vm.accounts,
      "input-class": "input-author",
      "results-display": _vm.formattedDisplay,
      "initial-value": _vm.author,
      "initial-display": _vm.author,
      "results-property": "data"
    },
    on: {
      "selected": _vm.addAuthor,
      "clear": _vm.clearAuthor
    },
    nativeOn: {
      "keypress": function($event) {
        return _vm.autompletePrevent($event)
      }
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-table"
  }, [_c('div', {
    staticClass: "filter-slot",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "edit-filter-title"
  }, [_vm._v("可閱覽單位")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.secretSelect
    },
    model: {
      value: (_vm.filter.secret.selected),
      callback: function($$v) {
        _vm.$set(_vm.filter.secret, "selected", $$v)
      },
      expression: "filter.secret.selected"
    }
  }, _vm._l((_vm.filter.secret.selectedFilters), function(selectedFilter) {
    return _c('el-option', {
      key: selectedFilter.value,
      attrs: {
        "label": selectedFilter.text,
        "value": selectedFilter.value
      }
    }, [_vm._v(_vm._s(selectedFilter.text))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-slot"
  }, [_c('div', {
    staticClass: "edit-filter-title"
  }, [_vm._v("適合程度")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.levelSelect
    },
    model: {
      value: (_vm.filter.level.selected),
      callback: function($$v) {
        _vm.$set(_vm.filter.level, "selected", $$v)
      },
      expression: "filter.level.selected"
    }
  }, _vm._l((_vm.filter.level.selectedFilters), function(selectedFilter) {
    return _c('el-option', {
      key: selectedFilter.value,
      attrs: {
        "label": selectedFilter.text,
        "value": selectedFilter.value
      }
    }, [_vm._v(_vm._s(selectedFilter.text))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-table"
  }, [_c('el-form', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "inline": false
    }
  }, [_c('div', {
    staticClass: "edit-keyword-title"
  }, [_vm._v("關鍵字")]), _vm._v(" "), _c('input-tag', {
    ref: "keyword",
    attrs: {
      "tags": _vm.$store.state.editResource.keywords,
      "placeholder": "填入關鍵字…"
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.$store.state.editResource, "keywords", $event)
      }
    },
    nativeOn: {
      "keypress": function($event) {
        return _vm.prevent($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": false
    }
  }, [_c('div', {
    staticClass: "edit-file"
  }, [_vm._v("檔案上傳")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "files",
    attrs: {
      "type": "file",
      "id": "files",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.handleFilesUpload()
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "upload-btn",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("選取檔案\n\t\t\t\t"), _c('img', {
    staticClass: "upload-icon",
    attrs: {
      "src": require("../../assets/icon/ic_upload.png"),
      "alt": "U"
    }
  })]), _vm._v(" "), _vm._l((this.$store.state.editResourceFileAttrs), function(attr, index) {
    return _c('div', {
      key: index,
      attrs: {
        "id": 'file-' + index
      }
    }, [_c('div', {
      staticClass: "attrs-btn"
    }, [_c('div', {
      staticClass: "attrs-title"
    }, [_vm._v(" " + _vm._s(attr.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "loading-area"
    }, [_c('circle2', {
      staticClass: "attrs-uploading-icon",
      attrs: {
        "id": 'circle-' + index
      }
    })], 1), _vm._v(" "), _c('img', {
      staticClass: "attrs-clear-icon",
      attrs: {
        "id": 'close-' + index,
        "src": require("../../assets/icon/ic_clear.png"),
        "alt": "C"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(_vm.$store.state.tempEditResourceFileAttrsIds[index])
        }
      }
    })])])
  })], 2)], 1), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.edit),
      expression: "hint.display && this.$store.state.hintStatus.edit"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-978fed2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Edit.vue
// module id = 947
// module chunks = 170